<template>
  <div class="entry-overview flex max-w-8xl overflow-hidden bg-white shadow sm:rounded-lg">
    <div class="entry-detail w-full">
      <div class="flex flex-col">
        <main class="flex-1">
          <div class="relative mx-auto mt-6 p-4">
            <TableWithCondensedContent
              :table-headers="tableHeaders"
              table-bold
              :table-rows="tableRows"
              :items-per-page="25"
              :button="false"
              has-cell-link
              cell-link-text="Impersonate"
              has-paginator
              has-search
              search-placeholder="Search for a user"
              table-placeholder-text="No users found.">
              <template #header>
                <h2 class="text-lg font-medium text-gray-800">
                  Find user
                </h2>
              </template>
            </TableWithCondensedContent>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script setup>
/* external */
import {
  computed, ref,
} from 'vue';

/* local */
import TableWithCondensedContent from '@/Components/Lists/TableWithCondensedContent.vue';

/* *********************************************************************
 * Component declarations
 * ****************************************************************** */
const props = defineProps({
  users: {
    type: Array,
    required: true,
  },
});

const users = ref(props.users);

const tableHeaders = [
  'User', 'Teams',
];

const tableRows = computed(() => users.value.map((user) => [
  user.name,
  Object.values(user.allTeams).map((team) => team.name).join(', '),
  route('admin.impersonate.user', { user: user.id }),
]));

</script>
